module.exports = require("react-image-magnify");


//////////////////
// WEBPACK FOOTER
// external "react-image-magnify"
// module id = 362
// module chunks = 0